import { SystemIntelligenceView } from '@/components/systems/SystemIntelligenceView'
import { soloPage } from '@/lib/solo-data'

/**
 * Solo's drill-down — the submission path from dealer to signed deal.
 *
 * Rendered compact (see `soloPage`): this screen is meant to fit a desktop
 * viewport without the content column scrolling, which the tighter bands in
 * `SystemIntelligenceView` are what buy. Adding a panel or a table row here will
 * bring the scrollbar back, so measure rather than eyeball after a change.
 */
export function SoloSalesSubmission() {
  return <SystemIntelligenceView {...soloPage} />
}
